import { createFileRoute } from '@tanstack/react-router'
import React from 'react'
import { SiteVacancies } from '../site/components/site-vacancies'

export const Route = createFileRoute('/_auth/_main/websites/$siteId/settings/vacancies')({
    component: Vacancies,
})

function Vacancies() {
    const { siteId } = Route.useParams()

    return <SiteVacancies siteId={siteId} />
}
